import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CarDvlaTab } from '@features/cars/components/CarDvlaTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/cars/staff/$carId/dvla')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'DVLA',
        },
    },
})

function RouteComponent() {
    const { carId } = Route.useParams()

    return (
        <div className='h-full min-h-0'>
            <QueryErrorBoundary title='Failed to load DVLA details'>
                <Suspense fallback={<LoadingIndicator resource='DVLA details' />}>
                    <CarDvlaTab carId={carId} ownerType='staff' />
                </Suspense>
            </QueryErrorBoundary>
        </div>
    )
}
